import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppSelector } from 'store/hooks';

import { USER_ROLES } from 'constants/common';

import * as api from 'api/methods';

import { showToast } from 'helpers/showToast';

import { userSelector } from 'store/auth/selectors';

import { useFetch } from 'hooks/useFetch';

import LessonCategoryPage from './LessonCategoryPage';

const LessonCategoryPageContainer = () => {
  const user = useAppSelector(userSelector);

  const { id: categoryId } = useParams();

  const [saveLoading, setSaveLoading] = useState(false);
  const [autoSaveLoading, setAutoSaveLoading] = useState(false);

  const isRootAdmin = user.role === USER_ROLES.ROOT_ADMIN;

  const {
    loading,
    data: category,
    setState: setCategory,
  } = useFetch(
    {
      defaultData: [],
      fetcher: api.getLessonCategoryById,
      immediately: true,
      stopRequest: false,
    },
    categoryId,
    [categoryId],
  );

  const handleAutoSaveSubmit = async (values: any) => {
    if (category.name === values.name) {
      return;
    }

    try {
      setAutoSaveLoading(true);

      const data = { name: values.name };

      const updatedCategory = await api.updateLessonCategoryById({
        categoryId,
        data,
      });

      setCategory((prevState: any) => ({
        ...prevState,
        data: updatedCategory,
      }));
    } catch (error) {
      showToast({
        data: {
          title: 'Server error!',
          text: 'Something went wrong',
        },
      });
    }

    setAutoSaveLoading(false);
  };

  const handleSaveClick = async (values: any) => {
    setSaveLoading(true);

    const data = { name: values.name };

    try {
      const updatedCategory = await api.updateLessonCategoryById({
        categoryId,
        data,
      });

      setCategory((prevState: any) => ({
        ...prevState,
        data: updatedCategory,
      }));

      showToast({
        data: {
          variant: 'success',
          title: 'Success!',
          text: 'Category is successfully saved',
        },
      });
    } catch (error) {
      showToast({
        data: {
          title: 'Server error!',
          text: 'Something went wrong',
        },
      });
    }

    setSaveLoading(false);
  };

  return (
    <LessonCategoryPage
      isRootAdmin={isRootAdmin}
      loading={loading}
      saveLoading={saveLoading}
      autoSaveLoading={autoSaveLoading}
      category={category}
      onAutoSaveSubmit={handleAutoSaveSubmit}
      onSaveClick={handleSaveClick}
    />
  );
};

export default React.memo(LessonCategoryPageContainer) as any;
